import React from 'react';
import cn from 'classnames';

import { Header } from './Header';
import s from './style.module.css';

const GuestLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={s.root}>
    <Header />
    <div className={cn(s.contentWrapper)}>
      <div className={cn(s.content)}>{children}</div>
    </div>
  </div>
);

export { GuestLayout };
